/**
 * Contains all colors we can choose between
 */

export class Colors {
    static readonly Primary = 'color-primary';
    static readonly Secondary = 'color-secondary';
    static readonly Tertiary = 'color-tertiary';
    static readonly Success = 'color-success';
    static readonly Danger = 'color-danger';
    static readonly Warning = 'color-warning';
    static readonly Info = 'color-info';
    static readonly Light = 'color-light';
    static readonly Dark = 'color-dark';
    static readonly Black = 'color-black';
    static readonly White = 'color-white';
    static readonly Transparent = 'color-transparent';
}

export class BackgroundColors {
    static readonly Primary = 'bg-primary';
    static readonly Secondary = 'bg-secondary';
    static readonly Tertiary = 'bg-tertiary';
    static readonly Success = 'bg-success';
    static readonly Danger = 'bg-danger';
    static readonly Warning = 'bg-warning';
    static readonly Info = 'bg-info';
    static readonly Light = 'bg-light';
    static readonly Dark = 'bg-dark';
    static readonly Black = 'bg-black';
    static readonly White = 'bg-white';
    static readonly Transparent = 'bg-transparent';

    public static getColor(color: string): string {
        switch (color) {
            case 'Primary': {
                return BackgroundColors.Primary;
            }
            case 'Secondary': {
                return BackgroundColors.Secondary;
            }
            case 'Tertiary': {
                return BackgroundColors.Tertiary;
            }
            case 'Success': {
                return BackgroundColors.Success;
            }
            case 'Danger': {
                return BackgroundColors.Danger;
            }
            case 'Warning': {
                return BackgroundColors.Warning;
            }
            case 'Info': {
                return BackgroundColors.Info;
            }
            case 'Light': {
                return BackgroundColors.Light;
            }
            case 'Dark': {
                return BackgroundColors.Dark;
            }
            case 'White': {
                return BackgroundColors.White;
            }
            case 'Transparent': {
                return BackgroundColors.Transparent;
            }
        }
        return BackgroundColors.Tertiary;
    }
}

export class TextColors {
    static readonly Primary = 'text-primary';
    static readonly Secondary = 'text-secondary';
    static readonly Tertiary = 'text-tertiary';
    static readonly Success = 'text-success';
    static readonly Danger = 'text-danger';
    static readonly Warning = 'text-warning';
    static readonly Info = 'bg-info';
    static readonly Light = 'text-light';
    static readonly Dark = 'text-dark';
    static readonly Black = 'text-black';
    static readonly White = 'text-white';
    static readonly Transparent = 'text-transparent';
}

export type ColorTypes = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';
